export default {
  methods: {
    /**
     * storeに処理開始設定.
     */
    startLoading() {
      this.$store.dispatch('doSetLoading', { loading: true })
    },
    /**
     * storeに処理終了設定.
     */
    stopLoading() {
      this.$store.dispatch('doSetLoading', { loading: false })
    },
  },
}
